import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  selectMatrizDataAnalisada,
  selectMatrizCenario,
} from 'redux/reducers/relatoriosMatrizReducer';
import { MatrizSecaoParams } from 'types/Relatorios/Matriz';

// Subconjunto de MatrizSecaoParams resolvido pelo slice `relatoriosMatriz`
// (data_rodada + cenario). Os demais campos (matriz/mes/subsistema) são
// estado local do componente da Task 3, não vêm do Redux.
export type MatrizBaseParams = Pick<MatrizSecaoParams, 'data_rodada' | 'cenario'>;

/**
 * Deriva `data_rodada` (ISO) + `cenario` do slice `relatoriosMatriz`. Ao
 * contrário de `useSemanalSecaoParams`, não inclui os campos de filtro
 * (matriz/mês/subsistema) — esses são estado local do componente (Task 3),
 * não vêm do Redux.
 *
 * `useMemo` sobre os primitivos `[ano, mes, dia, cenario]` (NÃO sobre o
 * objeto do selector, que retorna nova ref a cada render) e devolve uma
 * referência estável enquanto os valores não mudarem — evita refetch
 * desnecessário do RTK Query.
 */
export default function useMatrizSecaoParams(): MatrizBaseParams {
  const { ano, mes, dia } = useSelector(selectMatrizDataAnalisada);
  const cenario = useSelector(selectMatrizCenario);

  return useMemo(() => {
    const mm = String(mes).padStart(2, '0');
    const dd = String(dia).padStart(2, '0');
    return { data_rodada: `${ano}-${mm}-${dd}`, cenario };
  }, [ano, mes, dia, cenario]);
}
